module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{},"en":{"Перевод между своими счетами":"Transfer between your accounts","Получатель":"Recipient","Введите номер счета":"Enter account number","Назначение":"Description","Номер счета получателя":"Recipient account number"}}')
  delete Component.options._Ctor
}
